export function getCurrentUser() {
  const token = localStorage.getItem('zf_token')
  if (!token) return null
  try {
    return JSON.parse(atob(token.split('.')[1]))
  } catch {
    return null
  }
}

export function hasRole(minRole) {
  const order = { basico: 0, intermediario: 1, master: 2 }
  const user = getCurrentUser()
  if (!user) return false
  return (order[user.role] ?? -1) >= (order[minRole] ?? 99)
}
